import { h, render } from 'preact'

import { googleMapsDirectionsUrl } from '../utils'

const InfoWindow = ({name, address, lat, lng, cre, info, products, links, close}) => {
    return (
        <div class="nm-infowindow">
            <div class="nm-infowindow-container">
                <div class="nm-infowindow-title">
                    <div class="nm-infowindow-name">{name}</div>
                </div>
                <div class="nm-infowindow-details">
                    <div class="nm-infowindow-address">
                        <p>{[address.street, address.city, address.state, address.zip].join(", ")}</p>
                    </div>
                    <div class="nm-infowindow-info">
                        <p>CRE: { cre }</p>
                    </div>
                    <div class="nm-infowindow-info">
                        <p>{ info }</p>
                    </div>
                    <div class="nm-infowindow-fuels">
                        <ul>
                            {
                                products.map(p => <li><img src={require(`../images/${p.replace(/ /,"-")}.png`)} /></li>)
                            }
                        </ul>
                    </div>
                    { !links &&
                        <div class="nm-infowindow-navlinks">
                            <ul>
                                <li><a target="_blank" href={googleMapsDirectionsUrl({lat, lng})}>Cómo llegar</a></li>
                            </ul>
                        </div>
                    }
                    { links && links.length > 0 &&
                        <div class="nm-infowindow-navlinks">
                            <ul>
                                { links.map(l => <li><a target="_blank" href={l.url}>{l.label}</a></li>)}
                            </ul>
                        </div>
                    }
                </div>
                <div class="nm-infowindow-closer" onClick={close}></div>
            </div>
        </div>)
}

export default InfoWindow
